import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { GroupDetailsPage } from '@frontend/features/provider-network/pages/GroupDetailsPage';
import type { ProviderGroupTab } from '@frontend/features/provider-network/types/providerNetwork.types';

// Create a type-safe validator for the tab search parameter
const tabValues: [ProviderGroupTab, ...ProviderGroupTab[]] = [
  'general',
  'contacts',
  'clinics',
  'features',
  'contract',
  'components',
  'note',
  'documents',
];

export const Route = createFileRoute('/provider-network/group/$groupId/')({
  component: GroupDetailsPage,
  validateSearch: z.object({
    tab: z.enum(tabValues).optional(),
    id: z.string().optional(),
    // Preserve return location and search state for back navigation
    returnTo: z
      .enum(['/provider-network/groups', '/provider-network/clinics'])
      .optional(),
    returnSearch: z.any().optional(),
  }),
});
